import React from "react";
import { useState } from "react";
import axios from "axios";
import FormInputs from './FormInputs'
import useSurveyFormContext from '../../../hooks/useSurveyFormContext'

const SurveyForm = () => {

    const {
        page,
        setPage,
        data,
        setData,
        title,
        canSubmit,
        disablePrev,
        disableNext,
        prevHide,
        nextHide,
        submitHide
    } = useSurveyFormContext()

    const [processing, setProcessing] = useState(false)

    const handlePrev = () => {
        document.getElementById("parkandtrailssurvey").scrollIntoView({behavior: "smooth"})
        setPage(prev => prev - 1)
    }

    const handleNext = () => {
        document.getElementById("parkandtrailssurvey").scrollIntoView({behavior: "smooth"})
        setPage(prev => prev + 1)
    }

    const handleSubmit = e => {
        e.preventDefault()
        if(processing) {

        } else {
            setProcessing(true)
            const  payload = {payload: data}
            axios.post('https://tally.tsds.info/api/forms/3/submit', payload)
            .then(response => {
                console.log(response.data)
                if(response.data.status === "PASS") {
                    setData({
                        email: "",
                        ageRange: "",
                        recFacilities: "",
                        mobility: [],
                        pocketParks: [],
                    })
                    setPage(1)
                } else {
                    setProcessing(false)
                }
            });
        }

        // .then(response => this.setState({ articleId: response.data.id }));
    }
    


    const content = (
        <form className="form flex-col" onSubmit={handleSubmit}>

            <header className="flex justify-between items-center mb-5">
                <h2 id="parkandtrailssurvey" className="text-header font-light text-3xl">{title[page]}</h2>
            </header>


            <FormInputs />

            <header className="flex justify-end items-center mb-5">

                <div className="button-container -mr-5">

                    <button type="button" className={`mr-5 font-medium uppercase rounded-full bg-neutral-300 dark:bg-neutral-700 hover:bg-neutral-400 hover:dark:bg-neutral-800 px-4 py-1 ${prevHide}`} onClick={handlePrev} disabled={disablePrev}>PREV</button>

                    <button type="button" className={`mr-5 font-medium uppercase rounded-full bg-neutral-300 dark:bg-neutral-700 hover:bg-neutral-400 hover:dark:bg-neutral-800 px-4 py-1 ${nextHide}`} onClick={handleNext} disabled={disableNext}>NEXT</button>

                    <button type="submit" className={`mr-5 font-medium uppercase rounded-full bg-green-300 dark:bg-green-700 hover:bg-green-400 hover:dark:bg-green-800 px-4 py-1 ${submitHide}`} disabled={!canSubmit || processing}>SUBMIT</button>
                </div>
            </header>

        </form>
    )

    return content
}
export default SurveyForm
